<template lang="html">

    <div>


        <div class="contenedor-botones row-start">

            <button class="btn -solid-primary" @click="aceptar">{{$t('candidaturas_options.aceptar')}}</button>
            <button class="btn -skull-primary" @click="showrechazar= true">{{$t('candidaturas_options.rechazar')}}</button>

        </div>


    <div class="cover-popup -middle row-center" v-if="showrechazar">

      <div class="popup">

        <a @click="showrechazar= false" class="close">✕</a>

        <h2 class="title-pop">{{$t('candidaturas_options.motivos_rechazo')}}</h2>

        <div class="contenedor-input">
          <select v-model="idMotivo" v-validate="'required'" name="estado">
            <option value="">{{$t('candidaturas_options.selecciona_motivo')}}</option>
            <template v-for="(motivo, key) in motivos">
              <option v-if="motivo.idEstado == 17 && (motivo.idPerfil == typenumber || !!!motivo.idPerfil)" :value="motivo.idMotivo">{{motivo.descripcion}}</option>
            </template>
          </select>
          <span class='error' v-if="clicked">{{ errors.first('estado')}}</span>
        </div>


        <button class="btn -solid-primary" @click="showrechazar = false; showAvisoRechazado = true;">{{$t('candidaturas_options.rechazar_preinscripcion')}}</button>

      </div>
    </div>


    <div class="cover-popup -middle row-center" v-if="showAvisoRechazado">

      <div class="popup">

        <a @click="rechazar" class="close">✕</a>
        </br>
        <p>Lamentamos que rechaces la plaza de prácticas en el centro que se te ha asignado.</p>
        <p>Todos los centros con los que colaboramos están cualificados para desarrollar las competencias del ciclo que has cursado.</p>
        <p><b>Reiteramos que la obligación del centro es la asignación de un centro de prácticas en la provincia donde el alumno está matriculado, y que el criterio interno de asignación es académico y por cercanía geográfica.</b> Son los centros de prácticas los que nos comunican su disponibilidad y capacidad para acoger alumnos, y la asignación de plazas de prácticas está supeditada a esto.</p>
        <p>El rechazo de una plaza de prácticas no justificado por causas de salud o fuerza mayor conlleva la firma del anexo de renuncia/aplazamiento pertinente. No se consideran causas de fuerza mayor la incompatibilidad laboral o la conciliación familiar; desde la matrícula, el alumno conoce el periodo de prácticas y que su realización es obligatoria.</p>
        <p>En los casos de aplazamiento, las prácticas habrán de llevarse a cabo dentro del año escolar, en el próximo periodo, finalizando siempre antes del fin del mismo (finales de Junio). De lo contrario, el alumno deberá valorar la opción de solicitar volverse a matricular asumiendo el recargo económico correspondiente.</p>
        <p>A continuación, te dejamos los enlace a la Normativa del Ministerio de Educación y Formación Profesional y de las comunidades autónomas:</p>

        <p><a target="_blank" href="https://www.todofp.es/comunidad-docente/normativa/normativa-estatal/ordenacion.html">Ministerio de Educación y FP.</a></p>
        <p><a target="_blank" href="https://www.comunidad.madrid/sites/default/files/resolucion_intrucciones_ordenacion_fp_dgesfpre_2025-2026_.pdf">Comunidad de Madrid.</a></p>
        <p><a target="_blank" href="https://triaeducativa.gencat.cat/web/.content/fp/formacio-centres-treball/normativa-formacio-centres-treball.pdf">Comunidad Autónoma de Cataluña.</a></p>
        <p><a target="_blank" href="https://www.juntadeandalucia.es/boja/2025/187/c01/BOJA25-218701-00037-12937-01_00326535.pdf">Andalucía.</a></p>
        <p><a target="_blank" href="https://dogv.gva.es/datos/2025/07/21/pdf/2025_28562_es.pdf">Generalitat Valenciana.</a></p>
        <p><a target="_blank" href="https://www.llegarasalto.com/wp-content/uploads/2025/10/Instucciones-GM-y-GS-2025.pdf">Región de Murcia.</a></p>

        <!-- <button class="btn -solid-primary" @click="rechazar">{{$t('candidaturas_options.rechazar_preinscripcion')}}</button> -->

      </div>
      
    </div>

  </div>

</template>

<script lang="js">
  
    import {mapGetters,mapActions} from 'vuex'

    import VeeValidate from 'vee-validate';
  
    export default  {
      name: 'candidatura-options',
      props : ['url','type'],
      data(){
          return{
            showrechazar : false,
            showAvisoRechazado: false,
            idMotivo : '',
            clicked : false
          }
      },
      computed: {
        ...mapGetters({
          style : 'getStyles',
          motivos : 'getmotivosRechazo'
        }),
        typenumber(){
          let type = new Number();

          type = (this.type == 'empleo') ? 1 : 2;

          return type;
        }
      },  
        methods : {
            ...mapActions(['aceptarPreinscripcion','rechazarPreinscripcion']),
            aceptar(){
                let data = {"urlOferta" : this.url}
                this.aceptarPreinscripcion(data).then( r => {});
            },
            rechazar(){
                this.clicked = true;
                this.$validator.validateAll().then(itsOk => {
                    if (itsOk) {

                    let data = {
                        "urlOferta" : this.url,
                        'idMotivo' : this.idMotivo
                    };
            
                    this.rechazarPreinscripcion(data).then( r => {
                        this.showAvisoRechazado = false;
                    });

                    }
                });

            }
      },
      components :{
      }
    }
  </script>
<style scoped lang="scss">


.contenedor-botones{
  margin-top: 15px;
  position: relative;
  z-index: 6;
  width: 100%;
}

.btn{
  margin-right: 10px;
  margin-bottom: 10px;
}

  
  </style>


// WEBPACK FOOTER //
// src/components/views/ofertas/candidatura-options.vue